import Layout from 'layout/Layout';

import {
  Login,
  Dashboard,
  Otp,
  Vendor,
  ViewVendor,
  SubVendorView,
  VechileSubVendorView,
  DriverTable,
  DriverView,
  ViewDriverVendor,
  CustomerTable,
  CustomerView,
  ComplianceTable,
  ComplianceDocument,
  RideTrack,
  RideTrackView,
  FeedbackTable,
  FeedbackBrief,
  Notification,
  Settings,
  AddComplianceView,
  AddFeedbackView,
  AddCabView,
  WelcomeITER,
  Signup,
  ChooseYourService,
  TableSubVendor,
  VechileTable,
  AssignTripView,
  AssignVechileView,
  AssignDriverView,
  FAQ,
  TripDetails,
  CustomerHelpFAQ,
  FAQView,
  ComplianceUpload,
  SupportConsole,
  // Reports,
  Invoice,
  AddSubVendorDriver,
  PolicyView,
  RateCard,
  InvoiceDetails,
  CustomerPolicy,
  CustomerAboutUs,
  CustomerTAC,
  Customer,
  Booking,
  BookingDetails
} from './components';

export const routeConfigAuth = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  { path: '/signup', component: Signup, layout: null, isAuth: false },
  {
    path: 'customerFaq',
    component: CustomerHelpFAQ,
    layout: null,
    isAuth: false,
  },
  { path: 'shareTrip', component: TripDetails, layout: null, isAuth: false },
  { path: 'privacy-policy', component: CustomerPolicy, layout: null, isAuth: false },
  { path: 'termsandconditions', component: CustomerTAC, layout: null, isAuth: false },
  { path: 'aboutus', component: CustomerAboutUs, layout: null, isAuth: false },
  { path: '/download-invoice/:id/:magicToken', component: InvoiceDetails, layout: null, isAuth: false },
];

export const routeConfigCommon = [
  { path: '/dashboard', component: Dashboard, layout: Layout, isAuth: true },
  { path: '/customer', component: CustomerTable, layout: Layout, isAuth: true },
  {
    path: '/customer/detail',
    component: CustomerView,
    layout: Layout,
    isAuth: true,
  },
  { path: '/driver', component: DriverTable, layout: Layout, isAuth: true },

  { path: '/driver/vehicle', component: VechileSubVendorView, layout: Layout, isAuth: true },
  {
    path: '/driver/details',
    component: DriverView,
    layout: Layout,
    isAuth: true,
  },
  { path: '/rideTrack/:tabs', component: RideTrack, layout: Layout, isAuth: true },
  {
    path: '/rideTrack/details',
    component: RideTrackView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/rideTrack/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/:tabs',
    component: ComplianceTable,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/documents',
    component: ComplianceDocument,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/feedback/details',
    component: FeedbackBrief,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/notification',
    component: Notification,
    layout: Layout,
    isAuth: true,
  },
  { path: '/settings', component: Settings, layout: Layout, isAuth: true },
  { path: '/support', component: SupportConsole, layout: Layout, isAuth: true },
  // { path: '/reports', component: Reports, layout: Layout, isAuth: true },
  { path: '/reports/booking', component: Booking, layout: Layout, isAuth: true },
  { path: '/reports/customer', component: Customer, layout: Layout, isAuth: true },
  { path: '/invoice', component: Invoice, layout: Layout, isAuth: true },
  { path: '/invoice/detail', component: InvoiceDetails, layout: Layout, isAuth: true },
  { path: '/feedback', component: FeedbackTable, layout: Layout, isAuth: true },
];

export const routeConfigAdmin = [
  { path: '/vendor', component: Vendor, layout: Layout, isAuth: true },
  {
    path: '/vendor/:city/:tabs',
    component: ViewVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/driver/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/subvendor',
    component: SubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/subvendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  // { path: '/feedback', component: FeedbackTable, layout: Layout, isAuth: true },
  {
    path: '/vendor/subvendor/driver/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/vendor/subvendor/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/addcomplaince',
    component: AddComplianceView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/addfeedback',
    component: AddFeedbackView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/addcabcategory',
    component: AddCabView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/policy',
    component: PolicyView,
    layout: Layout,
    isAuth: true,
  },
  { path: '/faq', component: FAQ, layout: Layout, isAuth: true },
  { path: '/faq/details', component: FAQView, layout: Layout, isAuth: true },
  { path: '/ratecard', component: RateCard, layout: Layout, isAuth: true },
  {
    path: '/assigntrip',
    component: AssignTripView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assignvechile',
    component: AssignVechileView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assigndriver',
    component: AssignDriverView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor',
    component: TableSubVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/details',
    component: SubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
];

export const routeConfigVendor = [
  {
    path: '/subvendor',
    component: TableSubVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/details',
    component: SubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/subvendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  { path: '/Vehicle', component: VechileTable, layout: Layout, isAuth: true },
  {
    path: '/Vehicle/details',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assigntrip',
    component: AssignTripView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assignvechile',
    component: AssignVechileView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assigndriver',
    component: AssignDriverView,
    layout: Layout,
    isAuth: true,
  },
  // { path: '/feedback', component: FeedbackTable, layout: Layout, isAuth: true },
  // {
  //   path: '/service',
  //   component: ChooseYourService,
  //   layout: null,
  //   isAuth: true,
  // },
  // { path: '/welcome', component: WelcomeITER, layout: null, isAuth: true },
  {
    path: '/uploadcompliance',
    component: ComplianceUpload,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/add',
    component: AddSubVendorDriver,
    layout: Layout,
    isAuth: true,
  }
];

export const routeConfigSubVendor = [
  { path: '/Vehicle', component: VechileTable, layout: Layout, isAuth: true },
  {
    path: '/Vehicle/details',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assigntrip',
    component: AssignTripView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/assignvechile',
    component: AssignVechileView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/service',
    component: ChooseYourService,
    layout: null,
    isAuth: true,
  },
  { path: '/welcome', component: WelcomeITER, layout: null, isAuth: true },
  {
    path: '/uploadcompliance',
    component: ComplianceUpload,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/add',
    component: AddSubVendorDriver,
    layout: Layout,
    isAuth: true,
  }
]
